import { render } from "./InactiveIcon.vue?vue&type=template&id=640f6a6a"
import script from "./InactiveIcon.vue?vue&type=script&lang=js"
export * from "./InactiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__